import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminAPI } from '../lib/api';

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      fetchAdminProfile(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchAdminProfile = async (token) => {
    try {
      const response = await adminAPI.getProfile();
      setAdmin(response.data);
      setIsAuthenticated(true);
    } catch (error) {
      localStorage.removeItem('adminToken');
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await adminAPI.login(email, password);
    const { token, admin: adminData } = response.data;
    localStorage.setItem('adminToken', token);
    setAdmin(adminData);
    setIsAuthenticated(true);
    return adminData;
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setAdmin(null);
    setIsAuthenticated(false);
  };

  return (
    <AdminContext.Provider value={{ admin, loading, isAuthenticated, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};
